module.exports = __webpack_public_path__ + "static/media/Monde_Cocktail_BG2.890b8ada.jpg";